module.exports = __webpack_public_path__ + "img/resume-builder-screenshot.c738bdf7.jpg";